import type {PropsWithChildren} from "react";
import {createContext} from "../../../../context/create-context";
import {type Error, HandleQuery} from "../../../../common/handle-query";
import {useParams} from "react-router-dom";
import {GetDiscountCodeApiResponse} from "../types";
import {useGetDiscountCode} from "../hooks/get-discount-code";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {FullPageLoader} from "../../../../components/full-page-loader";
import {Alert} from "antd";

type GetDiscountCodeState = {
  discountCodeData: GetDiscountCodeApiResponse;
};

type GetDiscountCodeContextState = {
  state: GetDiscountCodeState;
};

const [useContext, ContextProvider] = createContext<GetDiscountCodeContextState>();

export const useGetDiscountCodeContext = useContext;

export const GetDiscountCodeProvider = ({children}: PropsWithChildren) => {
  const {id} = useParams();

  return (
    <HandleQuery<GetDiscountCodeApiResponse, Error>
      query={useGetDiscountCode(id)}
      loader={
        <DashboardWrapper pageTitle={"Edit Discount"}>
          <FullPageLoader />
        </DashboardWrapper>
      }
      errorView={(err) => (
        <DashboardWrapper pageTitle={"Edit Discount"}>
          <Alert message="Error" description={err.message} type="error" showIcon />
        </DashboardWrapper>
      )}
      children={(query) => {
        return (
          <ContextProvider
            value={{
              state: {
                discountCodeData: query.data,
              },
            }}
          >
            {children}
          </ContextProvider>
        );
      }}
    />
  );
};
